import { PACKAGES_FETCH_REQUEST, PACKAGES_FETCH_SUCCESS, PACKAGES_FETCH_FAILURE } from './types';
import baseUrl from '../url'

const fetchPackagesRequest = () => {
    return {
        type: PACKAGES_FETCH_REQUEST
    }
}

const fetchPackagesSuccess = packages => {
    return {
        type: PACKAGES_FETCH_SUCCESS,
        payload: packages,
    }
}

const fetchPackagesFailure = error => {
    return {
        type: PACKAGES_FETCH_FAILURE,
        payload: error,
    }
}

export const getPackages = (slug) => {
    return (dispatch) => {
        if (slug) {

            dispatch(fetchPackagesRequest());
            fetch(`${baseUrl}/packages/${slug}`, {
                    method: 'GET'
                })
                .then(response => response.json())
                .then((response) => {
                    const res = {...response };
                    const packs = res.packages;
                    const sorted = packs.sort((a, b) => {
                        return a.order_in_duration - b.order_in_duration;
                    });
                    const averages = response.hours.map(i => {
                        return sorted.find(j => {
                            if (j.order === i) {
                                return j.average_frames;
                            }
                        })
                    });
                    response.packages = sorted;
                    response.averages = averages;
                    dispatch(fetchPackagesSuccess(response))
                })
                .catch((error) => {
                    dispatch(fetchPackagesFailure(error.message));
                })
        } else {
            dispatch(fetchPackagesSuccess({}));
        }
    }

}